import React from "react";
import "./styles.css";

const BackButton = (props) => {
  const { text, onClick, className } = props;
  return (
    <div className={`go-back-button ${className || ""}`} onClick={onClick}>
      <img src="/assets/icons/back-arrow.svg" alt="go-back" />
      {text}
    </div>
  );
};

export default BackButton;
